<template lang="pug">
  Auth(:redirectWithLoginFailed="true")
    Header(:content="headerContent")
    NowLoading(:show="isSaving")
    div.wrap-slide
      ModuleAddSlide(ref="modeulAddSlide")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-slide {
  width: 100%;
  min-height: 100vh;
  background: $primary_bg_color;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import NowLoading from '@/components/shared/NowLoading'
import Header from '@/components/shared/Header'
import ModuleAddSlide from '@/components/module/ModuleAddSlide'

export default {
  components: {
    Auth,
    NowLoading,
    Header,
    ModuleAddSlide
  },
  data () {
    return {
      headerContent: {
        title: 'Add Slide',
        left: {
          icon: 'mdi-close',
          to: '/mypage'
        },
        right: {
          label: 'OK',
          color: '#83f4ff',
          action: this.addSlide
        }
      },
      isSaving: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async addSlide () {
      if (this.isSaving) return

      const moduleAddSlideComponent = this.$refs.modeulAddSlide
      const slideUploaderComponent = moduleAddSlideComponent.$refs.slideUploader
      
      if (moduleAddSlideComponent.title === '') {
        alert('Type title')
        return
      }

      if (!slideUploaderComponent.base64Arr[0]) {
        alert('Upload pdf')
        return
      }

      if (slideUploaderComponent.isLoading
      || slideUploaderComponent.isUploading) {
          alert('Wait for finishing upload')
          return
      }

      this.isSaving = true
      this.headerContent.right.color = '#999'

      const slideObj = {
        title: moduleAddSlideComponent.title,
        description: moduleAddSlideComponent.description,
        pageDocs: slideUploaderComponent.base64Arr.map(e => e.id),
        currentPage: slideUploaderComponent.base64Arr[0].id,
        titleImg: slideUploaderComponent.base64Arr[0].uploadedURL,
        status: 'draft',
        createdBy: this.uid,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      console.log('addSlide:', slideObj)
      const slideId = await database.slideCollection().add(slideObj)
      console.log('slideId:', slideId)
      const promises = slideUploaderComponent.base64Arr.map(e => {
        return database.slideCollection().setPage(slideId, e.id, {
          imgURL: e.uploadedURL,
          createdBy: this.uid,
          createdAt: new Date()
        })
      })
      await Promise.all(promises).then(results => { 
        console.log('results:', results)
      }).catch(reject => { 
        console.log('reject:', reject)
      })

      this.isSaving = false
      this.$router.push(`/slide/${slideId}`)
    }
  }
}
</script>
